import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="binding"
export default class extends Controller {
  static targets = ["inputField", "priceColumn"]

  updateValues(event){
    this.inputFieldTargets.forEach(element => {
      if(element.dataset.bindingId == event.target.dataset.bindingId){
        if(event.target != element){
          element.value = event.target.value
        }
      }
    });
    this.updateTotalPrice(event.target.dataset.priceColumn)
  }

  updateTotalPrice(priceColumn){
    const columns = document.querySelectorAll(`[data-price-column='${priceColumn}']`)
    const total = document.querySelector(`[data-price-total='${priceColumn}']`)
    if (total) {
      let sum = 0
      columns.forEach(element => {
        sum += Number(element.value)
      })
      total.innerHTML = `$${sum}`
      total.dataset.value = sum
      this.updateTotalPercents(total)
    }
  }

  updateTotalPercents(total){
    const percentTarget = total.dataset.percentTarget
    const percentLocation = total.dataset.percentLocation
    const percentDiv = document.querySelector(`#${percentTarget}`)
    let percent
    let other
    if(percentDiv && percentLocation){
      if(percentLocation == 'up'){
        other = document.querySelector(`[data-percent-target='${percentTarget}'][data-percent-location='down']`)
        percent = (((total.dataset.value / other.dataset.value) - 1) * 100).toFixed(2)
      }else{
        other = document.querySelector(`[data-percent-target='${percentTarget}'][data-percent-location='up']`)
        percent = (((other.dataset.value / total.dataset.value) - 1) * 100).toFixed(2)
      }
      percentDiv.innerHTML = `${percent}%`
    }
  }

  updatePercents(event){
    //NTD This assumes only 2 tiers
    const percentTarget = event.target.dataset.percentTarget
    const percentLocation = event.target.dataset.percentLocation
    const percentDiv = document.querySelector(`#${percentTarget}`)
    let other
    let percent

    if (percentLocation && percentDiv){
      if(percentLocation == 'up'){
        other = document.querySelector(`[data-percent-target='${percentTarget}'][data-percent-location='down']`)
        percent = (((event.target.value / other.value) - 1) * 100).toFixed(2)
      }else{
        other = document.querySelector(`[data-percent-target='${percentTarget}'][data-percent-location='up']`)
        percent = (((other.value / event.target.value) - 1) * 100).toFixed(2)
      }
      percentDiv.innerHTML = `${percent}%`
    }

  }

}
